'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import { AlertTriangle, ArrowLeft, Loader2, RefreshCw } from 'lucide-react';
interface SpinUpStepProps {
  isError: boolean;
  error: Error | null;
  onRetry: () => void;
  onBack: () => void;
}
function SpinUpStep(t0) {
  const $ = _c(18);
  const {
    isError,
    error,
    onRetry,
    onBack
  } = t0;
  if (isError) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="bg-destructive/10 text-destructive flex size-12 items-center justify-center rounded-full"><AlertTriangle className="size-5" aria-hidden="true" /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <h2 className="text-2xl font-semibold tracking-tight">Couldn't create your drive</h2>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const t3 = error?.message;
    let t4;
    if ($[2] !== t3) {
      t4 = <div className="flex flex-col gap-2">{t2}<p className="text-muted-foreground max-w-md text-sm">{t3}</p></div>;
      $[2] = t3;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <ArrowLeft className="size-4" aria-hidden="true" />;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== onBack) {
      t6 = <Button variant="outline" onClick={onBack} className="gap-2">{t5}Go back</Button>;
      $[5] = onBack;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <RefreshCw className="size-4" aria-hidden="true" />;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    let t8;
    if ($[8] !== onRetry) {
      t8 = <Button onClick={onRetry} className="gap-2">{t7}Try again</Button>;
      $[8] = onRetry;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    let t9;
    if ($[10] !== t6 || $[11] !== t8) {
      t9 = <div className="flex flex-col gap-2 sm:flex-row">{t6}{t8}</div>;
      $[10] = t6;
      $[11] = t8;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    let t10;
    if ($[13] !== t4 || $[14] !== t9) {
      t10 = <Card className="overflow-hidden"><CardContent className="flex flex-col items-center gap-5 px-8 py-12 text-center">{t1}{t4}{t9}</CardContent></Card>;
      $[13] = t4;
      $[14] = t9;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    return t10;
  }
  let t1;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-primary/10 text-primary flex size-12 items-center justify-center rounded-full"><Loader2 className="size-5 animate-spin" aria-hidden="true" /></div>;
    $[16] = t1;
  } else {
    t1 = $[16];
  }
  let t2;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Card className="overflow-hidden"><CardContent className="flex flex-col items-center gap-5 px-8 py-12 text-center">{t1}<div className="flex flex-col gap-2"><h2 className="text-2xl font-semibold tracking-tight">Spinning up your drive</h2><p className="text-muted-foreground max-w-md text-sm">Hang tight — this takes just a few seconds.</p></div></CardContent></Card>;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  return t2;
}
export { SpinUpStep };